module.exports = __webpack_public_path__ + "static/media/ICONO-CARPETA-2.3837cd2f.png";